// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1HEZo","buttons":"PendingPaymentAlert_buttons__30-3c"};